"use client";

import { FaBoxOpen, FaBoxesPacking } from "react-icons/fa6";
import { generateIcon } from "utils";

export type shipmentToggleType = { shipped: boolean; id: string };

export function ShipmentToggler({
  id,
  shipped,
  handleClick,
  t,
  ...props
}: any) {
  return (
    <button
      type="button"
      title={t(shipped ? "Toast.deviceSent" : "Toast.sendDevice")}
      onClick={() => handleClick({ shipped, id })}
      className="flex flex-row items-end"
    >
      {shipped
        ? generateIcon(FaBoxesPacking, "w-[30px] h-[30px] text-purple-950")
        : generateIcon(FaBoxOpen, "w-[30px] h-[30px] hover:text-purple-500")}
    </button>
  );
}
